<div class="overflow-y-auto overflow-x-hidden zuper-scrollbar max-h-80 primary-font"
    *ngIf="totalJobs > 0 && options.url && options.paramObj" apiLazyLoading [dataURL]="options.url" [params]="paramObj"
    [totalPages]="totalPages" (isLoading)="showLazyLoading($event)" (emitter)="lazyLoadingEmit($event)">
    <div class="py-2 my-3 px-3 mx-3 flex flex-col bg-gray-50 rounded-lg" *ngFor="let data of jobs">
        <div class="flex">
            <a [matTooltip]="'#' + (data.prefix ? data.prefix : '') + (!utilityService.isEmptyOrUndefined(data.work_order_number) ? data.work_order_number : '') + ' - ' + data.job_title"
                class="my-1 text-base font-bold max-w-3/4 truncate hover:underline hover:text-primary-500 cursor-pointer"
                *ngIf="!data.is_deleted && utilityService.hasModuleAccess('JOB', false, 'from_sidebar')"
                [routerLink]="utilityService.getLink('JOB', data.job_uid)">
                #{{data.prefix ? data.prefix : ''}}{{!utilityService.isEmptyOrUndefined(data.work_order_number) ?
                data.work_order_number : ''}} - {{data.job_title}}</a>
            <a [matTooltip]="'#' + (data.prefix ? data.prefix : '') + (!utilityService.isEmptyOrUndefined(data.work_order_number) ? data.work_order_number : '') + ' - ' + data.job_title"
                class="my-1 text-base font-bold max-w-3/4 truncate cursor-default"
                *ngIf="data.is_deleted === true || !utilityService.hasModuleAccess('JOB', false, 'from_sidebar')">
                #{{data.prefix ? data.prefix : ''}}{{!utilityService.isEmptyOrUndefined(data.work_order_number) ?
                data.work_order_number : ''}} - {{data.job_title}}</a>
        </div>
        <div class="flex py-1" *ngIf="data.job_category?.category_name || data.job_status?.length > 0">
            <span *ngIf="data.job_category?.category_name"
                class="inline-flex px-3 rounded-full text-base font-medium bg-white text-gray-600 border h-6.5 mr-1">
                {{data.job_category.category_name}}
            </span>
            <span *ngIf="data.job_status?.length > 0"
                class="inline-flex px-3 rounded-full text-base font-medium bg-white text-gray-600 border h-6.5">
                <span class="mt-1.5">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle" width="11"
                        height="11" viewBox="0 0 24 24" stroke-width="0" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round" [ngClass]="getJobStatusClass(data.job_status)"
                        [ngStyle]="getstyles(data.job_status)">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <circle cx="12" cy="12" r="9"></circle>
                    </svg>
                </span>
                <span class="text-base capitalize px-1">
                    {{getJobsStatus(data.job_status).status_name | lowercase}}
                </span>
            </span>
        </div>
        <div class="flex flex-col">
            <span class="text-base text-gray-500 w-full" *ngIf="data.scheduled_start_time && data.scheduled_end_time">
                {{data.scheduled_start_time | datetime}}
                <span class="text-2xl h-5">&#8594;</span>
                {{data.scheduled_end_time |
                datetime}}
            </span>
            <span class="text-base text-gray-500 w-full font-medium max-w-3/4 truncate" *ngIf="data.due_date">
                {{'text.due_by' | translate}} {{data.due_date | dateformat:',
                dddd'}}
            </span>
        </div>
    </div>
</div>
<div class="flex justify-center w-full h-10 bg-white py-2"
    *ngIf="totalJobs > 0 && !(paramObj.count > totalJobs || totalJobs === jobs.length)">
    <mat-spinner [diameter]="20" *ngIf="isLazyLoading"></mat-spinner>
</div>